
import axios from 'axios';
// import { useHistory, useLocation } from 'react-router';
// import Axios from 'axios-observable';

import { CommonConfig } from '../../../../config/common-config';

export const createIMC = (data, axiosConfig) => {
    return axios.post(`${CommonConfig.dev.baseUrl}/api/auth/intclients`, data, axiosConfig)
        .then(response => response.data)
        // this.setState({ successMsg: 'Login Credentials are updated!!!' });
        .catch((error) => {
            // this.setState({ restPwdErrorMsg: 'correct credentials needed!!!' });
            // console.warn("FAILED to get all employees due to", error.toString());
        });
    // };

    // return Axios.post('http://172.16.238.236:5020/api/auth/intclients', data).subscribe(
    //     (result) => {
    //         //console.log("result", result);
    //         // const { history } = props;

    //         if (result.data) {
    //             ////console.log("result====> services", result.data);

    //             // setShowBtnLoader(false);
    //             //console.log("result.data", result.data);
    //             history.push('/menu/IMCView');
    //         }
    //     }
    //     // (error) => ////console.log(error)
    // );

    // .catch(error => {
    //     // console.warn("FAILED to get all employees due to", error.toString());
    //     return Promise.reject(error);
    // });
};

export const forgotPassword = (data) => {
    return axios.post(`${CommonConfig.dev.baseUrl}/api/auth/forgot-password `, data)
        .then(response => response.data)
        // this.setState({ successMsg: 'Login Credentials are updated!!!' });
        .catch((error) => {
            // this.setState({ restPwdErrorMsg: 'correct credentials needed!!!' });
            // console.warn("FAILED to get all employees due to", error.toString());
        });
};


export const PaymentsDetails = () => {
    return axios.get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history`)
        .then(response =>
            response.data.content
        )
        // this.setState({ successMsg: 'Login Credentials are updated!!!' });
        .catch((error) => {
            // this.setState({ restPwdErrorMsg: 'correct credentials needed!!!' });
            // console.warn("FAILED to get all employees due to", error.toString());
        });
};



